import { register as registerOneUxBarChart } from './one-ux-bar-chart/register-element.js';
import { register as registerOneUxDistribution } from './one-ux-distribution/register-element.js';
import { register as registerOneUxIndication } from './one-ux-indication/register-element.js';
import { register as registerOneUxPlotChart } from './one-ux-plot-chart/register-element.js';
import { register as registerOneUxProgress } from './one-ux-progress/register-element.js';
registerOneUxBarChart('one-ux-bar-chart');
registerOneUxDistribution('one-ux-distribution');
registerOneUxIndication('one-ux-indication');
registerOneUxPlotChart('one-ux-plot-chart');
registerOneUxProgress('one-ux-progress');